import type { WeekDay } from '@/modules/payments';

// Mirrors admin settings defaults in src/modules/admin/utils/settings-helpers.ts.
// The backend does not expose these in CollectorSummary, so we fall back
// to the same defaults the settings panel uses.
const DAYS_REQUIRED = 5;
const FAULT_THRESHOLD = 3;

export type RiskState =
  | { kind: 'warn'; daysLeft: number }
  | { kind: 'grace'; minDaily: number };

export type RiskInput = {
  status: string;
  days: WeekDay[];
  minDaily: number;
};

function countByState(days: WeekDay[], state: WeekDay['state']): number {
  return days.filter((d) => d.state === state).length;
}

function warnIfAtRisk(days: WeekDay[]): RiskState | null {
  const done = countByState(days, 'done');
  const faults = countByState(days, 'fail');
  if (done >= DAYS_REQUIRED) return null;
  if (faults < 1) return null;
  const daysLeft = FAULT_THRESHOLD - faults;
  if (daysLeft < 1) return null;
  return { kind: 'warn', daysLeft };
}

export function pickRisk({
  status,
  days,
  minDaily,
}: RiskInput): RiskState | null {
  if (status === 'pre_banned') return { kind: 'grace', minDaily };
  if (status !== 'healthy') return null;
  return warnIfAtRisk(days);
}
